// root '../../../';

// dependencies
import { Child } from 'pym.js';
// import { select } from 'd3-selection';

import * as d3 from 'd3';
import data from './data/data.json';


// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
import { stylePremium } from './utils/helpers';
// import config from './config';
// import graphic from './graphic';

// styles
import './styles/index.scss';
import './styles/graphic.scss';

/* develblock:start */
import meta from './data/meta.json';

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw });

window.onload = () => {
  // necessary evil for right now

  const { pymChild } = window;
  // delay the initial resizing to give Twitter time to render tweets
  setTimeout(() => { pymChild.sendHeight(); }, 250);
  window.dispatchEvent(new Event('resize'));
};

const CNNPolitics = true;
const CNNBusiness = false;

stylePremium(CNNPolitics, CNNBusiness);

function draw() {
  window.dispatchEvent(new Event('resize'));
}

// TEMPLATE CODE

const isMobile = window.innerWidth <= 768;

function appendImage(section, src, caption) {
  const media = section.append('div');
  const figure = media.append('figure').attr('class', 'figure_image');
  figure.append('img').attr('src', src);
  media.append('figcaption').html(caption);
}

function appendVideo(section, src, caption) {
  const media = section.append('div');
  const video = media.append('video')
    .attr('class', 'timeline-video')
    .attr('src', `media/${src}`)
    .property('autoplay', true)
    .property('loop', true)
    .property('muted', true);
  video.append('source').attr('type', 'video/mp4');
  media.append('figcaption').html(caption);
}

function appendGraphic(section, desktopSrc, mobileSrc) {
  const figure = section.append('figure').attr('class', 'figure_graphic');
  figure.append('img')
    .attr('class', 'graphic-img')
    .attr('src', isMobile ? `media/${mobileSrc}` : `media/${desktopSrc}`);
}

data.forEach((item) => {
  const entry = d3.select('#timeline')
    .append('div')
    .attr('class', 'timeline-entry');

  entry.append('h3')
    .attr('class', 'timeline-date')
    .html(item.date);

  const content = entry.append('div').attr('class', 'timeline-content');

  const section = content.append('section').attr('class', 'story-section');

  if (item.custom_override) {
    section.append('p').html(item.custom_override);
    return;
  }

  if (!item.copy) return;

  const mediaTypes = [];
  if (item.image) mediaTypes.push('image');
  if (item.video) mediaTypes.push('video');
  if (item.graphic_desktop || item.graphic_mobile) mediaTypes.push('graphic');

  const hasPlaceholders = {
    image: item.copy.includes('[image_here]'),
    video: item.copy.includes('[video_here]'),
    graphic: item.copy.includes('[graphic_here]'),
  };

  const anyPlaceholderFound = mediaTypes.some(type => hasPlaceholders[type]);

  if (anyPlaceholderFound) {
    const parts = item.copy.split(/(\[image_here\]|\[video_here\]|\[graphic_here\])/);

    parts.forEach((part) => {
      const trimmed = part.trim();
      if (!trimmed) return;

      if (trimmed === '[image_here]' && item.image) {
        appendImage(section, item.image, item.image_caption);
      } else if (trimmed === '[video_here]' && item.video) {
        appendVideo(section, item.video, item.video_caption);
      } else if (trimmed === '[graphic_here]' && (item.graphic_desktop || item.graphic_mobile)) {
        appendGraphic(section, item.graphic_desktop, item.graphic_mobile);
      } else {
        section.append('p').html(trimmed);
      }
    });
  } else {
    section.append('p').html(item.copy);

    if (item.image) {
      appendImage(section, item.image, item.image_caption);
    }
    if (item.graphic_desktop || item.graphic_mobile) {
      appendGraphic(section, item.graphic_desktop, item.graphic_mobile);
    }
    if (item.video) {
      appendVideo(section, item.video, item.video_caption);
    }
  }
});
